"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ControlText;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlLabel = _interopRequireDefault(require("../control-label"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

var _popover = _interopRequireDefault(require("../popover"));

var _icon = _interopRequireDefault(require("../icon"));

var _getWindow = _interopRequireDefault(require("../utils/get-window"));

var _excluded = ["id", "onChange", "value", "label", "aside", "type", "optional", "validationError", "errorStyle", "noAuto", "themeLabel", "themeControlInput", "themeControlWrapper"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propNames = ['id', 'value', 'onChange', 'type', 'label', 'noAuto', 'optional', 'aside', 'validationError', 'errorStyle', 'popoverProps', 'themeControlInput', 'themeControlWrapper', 'themeLabel', // Passed when used with the Form component
'initialValue', 'validator'];

function ControlText(_ref) {
  var id = _ref.id,
      _onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      label = _ref.label,
      aside = _ref.aside,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? false : _ref$optional,
      validationError = _ref.validationError,
      _ref$errorStyle = _ref.errorStyle,
      errorStyle = _ref$errorStyle === void 0 ? 'default' : _ref$errorStyle,
      _ref$noAuto = _ref.noAuto,
      noAuto = _ref$noAuto === void 0 ? false : _ref$noAuto,
      themeLabel = _ref.themeLabel,
      _ref$themeControlInpu = _ref.themeControlInput,
      themeControlInput = _ref$themeControlInpu === void 0 ? 'input' : _ref$themeControlInpu,
      themeControlWrapper = _ref.themeControlWrapper,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      popoverOpen = _useState2[0],
      setPopoverOpen = _useState2[1];

  var extraProps = (0, _omit.default)(props, propNames);
  var inputElement = (0, _react.useRef)(null);
  var errorElement = (0, _react.useRef)(null);

  var onErrorClick = function onErrorClick() {
    if (inputElement.current) inputElement.current.select();
  };

  var isActive = function isActive() {
    return (0, _getWindow.default)().document.activeElement === inputElement.current || (0, _getWindow.default)().document.activeElement === errorElement.current;
  };

  var onContainerMouseOver = function onContainerMouseOver() {
    if (isActive()) return;
    setPopoverOpen(true);
  };

  var onContainerMouseOut = function onContainerMouseOut() {
    if (isActive()) return;
    setPopoverOpen(false);
  };

  var renderLabel = function renderLabel() {
    return /*#__PURE__*/_react.default.createElement(_controlLabel.default, {
      text: label,
      id: id,
      aside: aside,
      optional: optional,
      themeLabel: themeLabel
    });
  };

  var inputProps = {
    id: id,
    name: id,
    onChange: function onChange(e) {
      return _onChange(e.target.value, id);
    },
    value: value,
    type: type,
    className: themeControlInput,
    'aria-required': !optional,
    'data-testid': "".concat(id, "-input")
  };

  if (noAuto) {
    inputProps.autoCapitalize = 'none';
    inputProps.autoCorrect = 'off';
    inputProps.spellCheck = false;
  }

  if (validationError) {
    inputProps['aria-invalid'] = true;
  }

  if (validationError && errorStyle === 'inline') {
    inputProps.className = "".concat(themeControlInput, " round-l flex-child-grow");
    inputProps.style = {
      boxShadow: 'inset 0 0 0 1px #f74e4e'
    };
  }

  var labelElement = label ? renderLabel() : null;

  var control = /*#__PURE__*/_react.default.createElement("input", _extends({}, inputProps, extraProps));

  if (errorStyle === 'inline') {
    if (validationError) {
      control = /*#__PURE__*/_react.default.createElement("div", {
        onMouseOver: onContainerMouseOver,
        onMouseOut: onContainerMouseOut,
        "data-testid": "control-text-container",
        className: "flex"
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        ref: inputElement,
        onFocus: function onFocus() {
          return setPopoverOpen(true);
        },
        onBlur: function onBlur() {
          return setPopoverOpen(false);
        }
      }, inputProps, extraProps)), /*#__PURE__*/_react.default.createElement(_popover.default, _extends({
        active: popoverOpen,
        content: validationError,
        placement: "top",
        "aria-label": "Validation error"
      }, props.popoverProps), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onFocus: function onFocus() {
          return setPopoverOpen(true);
        },
        onBlur: function onBlur() {
          return setPopoverOpen(false);
        },
        ref: errorElement,
        onClick: onErrorClick,
        "data-testid": "validation-error",
        role: "alert",
        className: "h-full bg-red color-white round-r px6"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "flex flex--center-cross flex--center-main"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "alert",
        passthroughProps: {
          fill: 'white',
          className: "cursor-pointer"
        }
      })))));
    }

    return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
      themeControlWrapper: themeControlWrapper,
      id: id
    }, labelElement, control);
  }

  return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
    themeControlWrapper: themeControlWrapper,
    id: id,
    validationError: validationError
  }, labelElement, control);
}

ControlText.propTypes = {
  /** Unique id for this control. Required if you want a `label`. */
  id: _propTypes.default.string.isRequired,

  /**
   * Invoked when the control's value changes.
   * Passed two arguments:
   *
   * - `value` the current value of the input passes as a string
   * - The `id` prop.
   */
  onChange: _propTypes.default.func.isRequired,

  /** The control's value. Can be an empty string to indicate no value. */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Type attribute to override the existing default of 'text' */
  type: _propTypes.default.string,

  /** Label for the control. */
  label: _propTypes.default.string,

  /** Enable/Disable browser enabled autocorrect or spelling suggestions from the element. */
  noAuto: _propTypes.default.bool,

  /** If provided, "(optional)" is appended to the value of the legend element. */
  optional: _propTypes.default.bool,

  /** Additional content inserted alongside the label element. */
  aside: _propTypes.default.node,

  /** If provided, the value of this propery displays as an error message. */
  validationError: _propTypes.default.node,

  /**
   * Sets the style of the error message. There are two options:
   *
   * - `default` the standard presentation control components display an error
   *   message: beneath the input.
   * - `inline` An error indicator is displayed to the right of the element
   *   with the value of `validationError` prop displayed in a tooltip.
   */
  errorStyle: _propTypes.default.oneOf(['default', 'inline']),

  /**
   * Props to pass directly to the [Popover](#popover) component when inline error validation is in use. See Popover's
   * documentation for details.
   */
  popoverProps: _propTypes.default.object,

  /** Classes to apply to the input element */
  themeControlInput: _propTypes.default.string,

  /** Classes to apply to the control wrapper */
  themeControlWrapper: _propTypes.default.string,

  /** classes to apply to the label element */
  themeLabel: _propTypes.default.string
};